import React, { useEffect, useState, useRef } from "react";
import AppHeader from "../../shared/components/AppHeader";
import "./contentLibrary.scss";
import ContentLists from "./ContentLists";
import ContentViewer from "./ContentViewer";
import DeleteAlert from "../../shared/components/DeleteAlert";
import ContentForm from "./ContentForm";
import ContentLibraryService from "../../services/ContentLibraryService/contentLibrary.service";
import PaginationComponent from "../../shared/components/PaginationComponent";
import EmptyState from "../../shared/components/EmptyState";
import QuickQuizForm from "./QuickQuizForm";
import Filters from "../../shared/components/Filters";
import TreeSelectComponent from "../../shared/components/TreeSelectComponent";
import { treeOptions } from "../Students";
import { Col, Divider, Row, Skeleton, DatePicker, Radio, Tabs } from "antd";
import CheckboxComponent from "../../shared/components/CheckboxComponent";
import ButtonComponent from "../../shared/components/ButtonComponent";
import BulkUpload from "../CourseStructure/Chapters/ChapterActions/BulkUpload";
import { ExerciseXslxHeaders } from "../../enums/exerciseXslxHeaders";
import { convertJsonToXslx } from "../../shared/utils/xlsxConverter";
import { DownloadOutlined, DownOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { dateFilterFunc } from "../../shared/utils/filter";


const ContentLibrary = () => {

  const location = useLocation();
  const [contentFilters, setContentFilters] = useState([
    {
      value: "PDF",
      checked: false,
    },
    {
      value: "Video",
      checked: false,
    },
  ]);
  const [currentContent, setCurrentContent] = useState<any>("");
  const [showContent, setShowContent] = useState<boolean>(false);
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const [formVisible, setFormVisible] = useState<boolean>(false);
  const [contents, setContents] = useState<any>([]);

  const [paginationMeta, setPaginationMeta] = useState<any>([]);
  const [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  const [perpage, setPerPage] = useState<number>(20)
  const [searchString, setSearchString] = useState<any>();

  const [showFilter, setFilterVisibility] = useState(false);
  const [showBulkUpload, setBulkUpload] = useState<boolean>(false);
  const [showQuickQuizForm, setQuickQuizFormVisible] = useState<boolean>(false);

  const [loading, setLoading] = useState(false);
  const [loadingContentsList, setLoadingContentsList] = useState(false);

  const [classified, setClassified] = useState<string>("");
  const [dateFilters, setDateFilters] = useState<any>({
    startingDate: "0",
    endingDate: "0",
  });
  const [visibilityFilter, setVisibilityFilter] = useState<string>("all");
  const searchTimeoutRef = useRef<any>(null);

  const handleDateFilterChange = (value: string) => {
    setClassified(value);

    if (value !== "month") {
      const dateRange = dateFilterFunc(value);
      setDateFilters((prev: any) => ({ ...prev, ...dateRange }));
    }
  };

  const handleMonthChange = (date: moment.Moment | null) => {
    if (date) {
      const monthRange = dateFilterFunc("month", date);
      setDateFilters((prev: any) => ({ ...prev, ...monthRange }));
    }
  };

  const handleResetDateFilter = () => {
    setClassified("");
    setDateFilters({
      startingDate: "0",
      endingDate: "0",
    });
  };

  useEffect(() => {
    fetchContentLibraryList(1, perpage, searchString);
  }, [dateFilters, visibilityFilter]);

  useEffect(() => {
    let contentID = location.state
    if (contentID !== undefined && contentID !== null) {
      fetchContentById(contentID)
    } else {
      fetchContentLibraryList(1, 20, "")
    }
  }, []);


  const fetchContentLibraryList = (
    pageNumber: number,
    perPage: number,
    searchString?: string
  ) => {
    setLoadingContentsList(true);
    let queryParams = `?page=${pageNumber}&search=${searchString || ""}&perpage=${perPage}&start_date=${dateFilters.startingDate}&end_date=${dateFilters.endingDate}`;
    if (visibilityFilter !== "all") {
      queryParams += `&visibility=${visibilityFilter}`;
    }
    ContentLibraryService.getContentLibraryList(
      queryParams,
      (contentLibrary: any, pageMeta: any) => {
        setContents(contentLibrary);
        setPaginationMeta(pageMeta);
        setLoadingContentsList(false);
      },
      () => { },
      () => { }
    ).then();
  };

  const fetchContentById = (contentId: any) => {
    setLoadingContentsList(true);
    setCurrentContent('');
    ContentLibraryService.getContentLibraryDetails(
      contentId,
      (content: any) => {
        setContents([content]);
      },
      () => { },
      () => {
        window.history.replaceState({}, document.title)
        setLoadingContentsList(false);
      }
    ).then();
  };

  const fetchContentDetails = (contentId: string) => {
    setLoading(true);
    setCurrentContent('');
    ContentLibraryService.getContentLibraryDetails(
      contentId,
      (content: any) => {
        setCurrentContent(content);
      },
      () => { },
      () => { setLoading(false); }
    ).then();
  };

  const handlePageChange = (page: number, pageSize: any) => {
    setPerPage(pageSize)
    setCurrentPageNumber(page);
    fetchContentLibraryList(page, pageSize, searchString);

  };

  const handleSearch = (value: string) => {
    if (location.state)
      window.history.replaceState({}, document.title)
    setSearchString(value)

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      fetchContentLibraryList(currentPageNumber, perpage, value);
    }, 500);
  };

  const handleDelete = () => {
    ContentLibraryService.deleteContent(
      currentContent?.id,
      () => {
        fetchContentLibraryList(currentPageNumber, perpage, searchString);
        setShowDelete(false);
      },
      () => { },
      () => { }
    ).then();
  };
  const handleDownload = () => {
    convertJsonToXslx("questions.xlsx", "Questions", [
      ExerciseXslxHeaders.EXERCISE_ID,
      ExerciseXslxHeaders.QUESTION_CONTENT,
      ExerciseXslxHeaders.QUESTION_IMAGE,
      ExerciseXslxHeaders.ONLY_FREE_TEXT,
      ExerciseXslxHeaders.OPTION1,
      ExerciseXslxHeaders.IMAGE_OPTION1,
      ExerciseXslxHeaders.OPTION2,
      ExerciseXslxHeaders.IMAGE_OPTION2,
      ExerciseXslxHeaders.OPTION3,
      ExerciseXslxHeaders.IMAGE_OPTION3,
      ExerciseXslxHeaders.OPTION4,
      ExerciseXslxHeaders.IMAGE_OPTION4,
      ExerciseXslxHeaders.CORRECT_ANSWER,
      ExerciseXslxHeaders.SOLUTION,
      ExerciseXslxHeaders.SOLUTION_IMAGE,
    ]);
  };



  return (
    <div className="page-view">
      <AppHeader
        handleSearch={handleSearch}
        buttonText="Content"
        handleHeaderAction={() => setFormVisible(true)}
        showFilter={true}
        headerText="Content Library"
        searchText={searchString}
      // handleFilter={() => setFilterVisibility(true)}
      />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <Tabs
          activeKey={visibilityFilter}
          onChange={(key) => setVisibilityFilter(key)}
          style={{ marginBottom: 0, flex: 2 }}

        >
          <Tabs.TabPane tab="All" key="all" />
          <Tabs.TabPane tab="Public" key="publicaly_visible" />
          <Tabs.TabPane tab="Unlisted" key="unlisted" />
        </Tabs>
        <div className="content-library__header-classifieds">
          {classified !== "" && (
            <CloseCircleOutlined
              onClick={handleResetDateFilter}
              className="reset-icon"
            />
          )}
          <Radio.Group
            onChange={(e) => handleDateFilterChange(e.target.value)}
            value={classified}
          >
            <Radio.Button value="today">Today</Radio.Button>
            <Radio.Button value="yesterday">Yesterday</Radio.Button>
            <Radio.Button value="week">Week</Radio.Button>
            <Radio.Button value="month">Month</Radio.Button>
          </Radio.Group>
          {classified === "month" && (
            <DatePicker
              picker="month"
              format="MMM YYYY"
              suffixIcon={<DownOutlined />}
              onChange={handleMonthChange}
            />
          )}
        </div>
      </div>
      <BulkUpload
        visible={showBulkUpload}
        closeHandler={() => {
          setBulkUpload(false);
        }}
      />
      <QuickQuizForm
        visible={showQuickQuizForm}
        closeModal={() => setQuickQuizFormVisible(false)}
        refreshList={() => fetchContentLibraryList(currentPageNumber, perpage, searchString)}
        currentContent={currentContent}
      />

      {loadingContentsList
        ? <>
          {[1, 2, 3, 5].map(rw => <Row key={"ROW#" + rw} className="content-list" gutter={[24, 12]}>
            {[1, 2, 3, 5].map(ske => <Col key={"COL#" + rw} xs={8} xl={6}>
              <div className="content-list__card" style={{ padding: 20 }}>
                <Skeleton active />
              </div>
            </Col>)}
          </Row>)}
        </>
        : contents.length !== 0 ? (
          <>
            <ContentLists
              contents={contents}
              currentContent={currentContent}
              setCurrentContent={fetchContentDetails}
              setShowContent={setShowContent}
              setShowDelete={setShowDelete}
              setShowForm={setFormVisible}
              setShowQuickQuizForm={setQuickQuizFormVisible}
            />
            <div className="content-library__footer">
              <PaginationComponent
                handlePageChange={handlePageChange}
                paginationMeta={paginationMeta}
              />
            </div>
          </>
        ) : (
          <EmptyState text={"No contents found."} />
        )}
      <ContentViewer
        visible={showContent}
        setVisible={setShowContent}
        content={currentContent}
        setCurrentContent={setCurrentContent}

      />
      <DeleteAlert
        visible={showDelete}
        setVisible={setShowDelete}
        deleteText={currentContent?.contentType + " Content"}
        deleteWarning="This content will be deleted permanently"
        contentThumbnail={currentContent?.displayPictureUrl}
        contentTitle={currentContent?.title}
        handleDelete={handleDelete}
      />
      <ContentForm
        loading={loading}
        title={currentContent === '' ? 'Create New Content' : ` Edit ${currentContent?.contentType === "pdf" ? "PDF" : "Video"} Content`}
        visible={formVisible}
        setVisible={setFormVisible}
        data={currentContent}
        setCurrentContent={setCurrentContent}
        currentPageNumber={currentPageNumber}
        refreshData={() => fetchContentLibraryList(currentPageNumber, perpage, searchString)}
      />
      <Filters
        expand={showFilter}
        handleApply={() => { }}
        handleReset={() => { }}
        closeHandler={() => setFilterVisibility(false)}
      >
        <CheckboxComponent
          group
          title={"Content type"}
          data={contentFilters}
          onChange={(index) => {
            let data = contentFilters;
            data[index].checked = !contentFilters[index].checked;
            setContentFilters([...data]);
          }}
        />
        <Divider />
        <TreeSelectComponent
          data={[{ title: "Boards", value: 0, children: treeOptions }]}
        />
        <Divider />
        <TreeSelectComponent
          data={[{ title: "Exams", value: 0, children: treeOptions }]}
        />
      </Filters>
      <Row
        className={`content-exercises__controllers ${!contents?.length ? "content-exercises__controllers-no-content" : ""
          }`}
        gutter={12}
      >
        <Col span={12}>
          <ButtonComponent
            type="text"
            iconLeft={<DownloadOutlined />}
            buttonContent="Template Excel"
            onClick={handleDownload}
          />
        </Col>
        <Col span={12}>
          <ButtonComponent
            type="primary"
            onClick={() => setBulkUpload(true)}
            buttonContent="Bulk Upload"
          />
        </Col>
      </Row>
    </div>
  );
};

export default ContentLibrary;
